import { Component, Input, OnInit } from '@angular/core';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { ApplicationStateStoreProxyService } from '@ddt-web/shared-stores';
import { UntilDestroy } from '@ngneat/until-destroy';
import { first } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'proposal-purpose',
	templateUrl: './proposal-purpose.component.html',
	styleUrls: ['./proposal-purpose.component.scss']
})
@UntilDestroy()
export class ProposalPurposeComponent implements OnInit {
	@InjectConfig(SharedConfigKey.PROPOSAL_PURPOSE_RISK_TOLERANCE_OPTIONS) public readonly riskToleranceOptions: string;
	@InjectConfig(SharedConfigKey.PROPOSAL_PURPOSE_OBJECTIVE_OPTIONS) public readonly objectiveOptions: string;

	@Input() public showPurposeValidation?: boolean; // driven by click on Generate button

	constructor(
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService
	) { }

	public proposalPortfolioName: string;
	public riskTolerance: string; // set default value from proposal store if set from web
	public objective: string; // set default value from proposal store if set from web

	public ngOnInit(): void {
		// initially setting the values from the proposalState
		this.applicationStateStoreProxyService.getProposalState().pipe(first()).subscribe(state => {
			const purposeState = state?.purpose;

			this.proposalPortfolioName = state.proposalPortfolioName;
			this.riskTolerance = purposeState?.riskTolerance || '';
			this.objective = purposeState?.objective || '';
		});
	}


	public onRiskToleranceChange(riskTolerance: string): void {
		this.riskTolerance = riskTolerance;
		this.updateProposalState();
	}

	public onObjectiveChange(objective: string): void {
		this.objective = objective;
		this.updateProposalState();
	}

	private updateProposalState(): void {
		this.applicationStateStoreProxyService.updateProposalPurpose({
			purpose: {
				riskTolerance: this.riskTolerance,
				objective: this.objective
			}
		});
	}
}
